import { createAction, props } from '@ngrx/store';

import { Candidate } from '@shared/models';

export const candidatesSelect = createAction(
  '[Collection Candidates] Select',
  props<{ id: number }>(),
);

export const candidatesGet = createAction('[Collection Candidates] Get ', props<{ id: number }>());

export const candidatesGetSuccess = createAction(
  '[Collection Candidates] Get Success',
  props<{ payload: Partial<Candidate> }>(),
);

export const candidatesGetFail = createAction('[Collection Candidates] Get Fail', props<any>());

export const candidatesUpdate = createAction(
  '[Collection Candidates] Update',
  props<{ payload: Partial<Candidate> }>(),
);

export const candidatesUpdateTalentPool = createAction(
  '[Collection Candidates] Update Talent Pool',
  props<{ payload: Partial<Candidate> }>(),
);

export const candidatesUpdateSuccess = createAction(
  '[Collection Candidates] Update Success',
  props<{ payload: Candidate }>(),
);

export const candidatesUpdateFail = createAction(
  '[Collection Candidates] Update Fail',
  props<any>(),
);

export const candidatesTalentPoolUpdateSuccess = createAction(
  '[Collection Candidates] Update Success',
  props<{ payload: Candidate }>(),
);
